import { Button } from 'components/Button';
import { LOGIN_URL } from 'config';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { Flex, FlexProps } from 'style/flexbox.style';

const NotSignedInUserFallback: React.FC<FlexProps> =
  function NotSignedInUserFallback({
    fluidHeight = true,
    justify = 'center',
    align = 'center',
    ...otherProps
  }) {
    return (
      <Flex
        fluidHeight={fluidHeight}
        justify={justify}
        align={align}
        {...otherProps}
      >
        <Button
          height={'29px'}
          minWidth={'none'}
          onClick={() => window.location.replace(LOGIN_URL)}
        >
          <Translate id="lbl.navbar.signIn" />
        </Button>
      </Flex>
    );
  };

export default NotSignedInUserFallback;
